import { cn } from "../lib/utils";

// A restrained, non-interactive status line for two-step verification. The word ("Enabled" /
// "Disabled") carries the state so it is understandable without colour; the small dot is the only
// element that carries semantic colour (green / muted red) and is hidden from assistive tech.
export function MfaStatusIndicator({ enabled }: { enabled: boolean }) {
  return (
    <p className="flex items-center gap-2">
      <span className="sr-only">Two-step verification status: </span>
      <span className="text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-foreground">
        {enabled ? "Enabled" : "Disabled"}
      </span>
      <span
        className={cn("size-2 shrink-0 rounded-full", enabled ? "bg-emerald-500" : "bg-rose-400")}
        aria-hidden="true"
      />
    </p>
  );
}
